import { defineStore } from "pinia"
import { useOsTheme } from "naive-ui"

export interface State {
  mode: string | null
}

const load = (): State => {
  const mode = localStorage.getItem("ux.mode")
  return { mode }
}

export const useUXStore = defineStore("ux", {
  state: () => load(),
  getters: {
    theme: (state) => {
      const osMode = useOsTheme()
      return state.mode || osMode.value || "light"
    }
  },
  actions: {
    setMode(mode: string) {
      this.mode = mode
      localStorage.setItem("ux.mode", mode)
    }
  }
})
